const env = import.meta.env;

function resolveApiBaseUrl(): string {
  const configured = env.VITE_API_BASE_URL;
  // Explicit empty / same-origin → Vite (or nginx) proxies /api to the gateway.
  if (configured === "" || configured === "/" || configured === "same-origin") {
    return "";
  }
  // When the SPA is opened via ngrok, never call http://localhost:8000 from the browser
  // (mixed content + host mismatch). Use same-origin so /api is proxied.
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host.includes("ngrok") || host.endsWith(".loca.lt")) {
      return "";
    }
  }
  return (configured || "http://localhost:8000").replace(/\/$/, "");
}

export const appConfig = {
  appName: env.VITE_APP_NAME || "MarketIQ",
  apiBaseUrl: resolveApiBaseUrl(),
  tokenStorageKey: env.VITE_TOKEN_STORAGE_KEY || "marketiq_token",
  refreshTokenStorageKey: env.VITE_REFRESH_TOKEN_STORAGE_KEY || "marketiq_refresh_token",
} as const;

export function apiUrl(path: string): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${appConfig.apiBaseUrl}${p}`;
}
